export const APP_NAME = 'desk';
